import React, { useEffect, useReducer, useRef } from 'react'
import ReactDOM from 'react-dom'
import useFloatingPosition from './useFloatingPosition'
import { getPortalContainer } from './portal'
import useStyles from './styles'


const tableActions = [
  { label: '↑ Row', title: 'Insert row above', run: chain => chain.addRowBefore() },
  { label: '↓ Row', title: 'Insert row below', run: chain => chain.addRowAfter() },
  { label: '← Column', title: 'Insert column left', run: chain => chain.addColumnBefore() },
  { label: '→ Column', title: 'Insert column right', run: chain => chain.addColumnAfter() },
  { divider: true },
  { label: 'Delete row', title: 'Delete row', run: chain => chain.deleteRow() },
  { label: 'Delete column', title: 'Delete column', run: chain => chain.deleteColumn() },
  { divider: true },
  { label: 'Header', title: 'Toggle header row', run: chain => chain.toggleHeaderRow() },
  { label: 'Merge/Split', title: 'Merge or split selected cells', run: chain => chain.mergeOrSplit() },
  { label: 'Delete table', title: 'Delete table', danger: true, run: chain => chain.deleteTable() }
]

const getActiveTable = (editor) => {
  if (!editor.isActive('table')) {
    return null
  }
  const { node } = editor.view.domAtPos(editor.state.selection.from)
  const element = node.nodeType === Node.TEXT_NODE ? node.parentElement : node
  return element && element.closest ? element.closest('table') : null
}

// Table controls shown above the table the cursor is in.
const TableMenu = ({ editor }) => {
  const localClasses = useStyles()
  const menuRef = useRef(null)
  const [, refresh] = useReducer(count => count + 1, 0)

  useEffect(() => {
    editor.on('transaction', refresh)
    editor.on('focus', refresh)
    editor.on('blur', refresh)
    return () => {
      editor.off('transaction', refresh)
      editor.off('focus', refresh)
      editor.off('blur', refresh)
    }
  }, [editor])

  const table = editor.isFocused ? getActiveTable(editor) : null

  useFloatingPosition(menuRef, () => table, { open: !!table, placement: 'top-end', gap: 6 }, [table])

  if (!table) {
    return null
  }

  return ReactDOM.createPortal(
    <div className={`${localClasses.popover} ${localClasses.tableMenu}`} ref={menuRef}>
      {
        tableActions.map((action, index) => (
          action.divider ?
          <span key={index} className={localClasses.menuDivider} /> :
          <button
            key={action.label}
            type='button'
            className={`${localClasses.menuButton} ${action.danger ? 'danger' : ''}`}
            title={action.title}
            onMouseDown={event => event.preventDefault()}
            onClick={() => action.run(editor.chain().focus()).run()}
          >
            {action.label}
          </button>
        ))
      }
    </div>,
    getPortalContainer(editor)
  )
}

export default TableMenu
